/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Enum for frequency
 * @export
 */
export const FrequencyEnum = {
    EveryWeek: 'EVERY_WEEK',
    EveryTwoWeeks: 'EVERY_TWO_WEEKS',
    EveryThreeWeeks: 'EVERY_THREE_WEEKS'
} as const;
export type FrequencyEnum = typeof FrequencyEnum[keyof typeof FrequencyEnum];


export function instanceOfFrequencyEnum(value: any): boolean {
    for (const key in FrequencyEnum) {
        if (Object.prototype.hasOwnProperty.call(FrequencyEnum, key)) {
            if (FrequencyEnum[key as keyof typeof FrequencyEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FrequencyEnumFromJSON(json: any): FrequencyEnum {
    return FrequencyEnumFromJSONTyped(json, false);
}

export function FrequencyEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrequencyEnum {
    return json as FrequencyEnum;
}

export function FrequencyEnumToJSON(value?: FrequencyEnum | null): any {
    return value as any;
}

export function FrequencyEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): FrequencyEnum {
    return value as FrequencyEnum;
}

